import {useCallback, useState} from 'react';

import {resolveInitiationMethod} from '@/features/buyers/utils';

import type {PartyType, PaymentMethod} from '@sollapay/enums';

/** The lawyer's payment-method pick — derived to "none" while it is PIS for a buyer that can't use PIS. */
export function usePaymentInitiationMethod(buyerPartyType: PartyType | undefined) {
  const [selectedInitiationMethod, setInitiationMethod] = useState<PaymentMethod | ''>('');

  const resetInitiationMethod = useCallback(() => setInitiationMethod(''), []);

  return {
    initiationMethod: resolveInitiationMethod(selectedInitiationMethod, buyerPartyType),
    selectedInitiationMethod,
    setInitiationMethod,
    resetInitiationMethod
  };
}
